module.exports = __webpack_public_path__ + "img/b_annuelle.8759d8a9.jpeg";